import type { LayeredProxyMetrics } from 'venn-api';
import { FREQUENCY_TO_ENUM, type FrequencyTypes, getProxyEndDate, getProxyStartDate } from 'venn-utils';

export type ProxyMetric = LayeredProxyMetrics['proxyMetricsList'][number];

export const getProxyRange = ({
  metric,
  investment,
}: {
  metric: ProxyMetric;
  investment: {
    id: string;
    updated: number;
    frequency: number | undefined;
    startRange: number | undefined;
    unproxiedEndRange: number | undefined;
    unproxiedStartRange: number | undefined;
    endRange: number | undefined;
  };
}): { start: number; end: number } | undefined => {
  const frequency = FREQUENCY_TO_ENUM[investment.frequency as FrequencyTypes];
  const extrapolate = metric.proxyType === 'EXTRAPOLATE' || metric.extrapolated;

  if (!metric.proxyType || !frequency || !investment.startRange || !investment.endRange) {
    return undefined;
  }

  let start = metric.proxiedStart;
  if (metric.proxyType === 'EXTRAPOLATE') {
    start =
      metric.extrapolatedStart ??
      (investment.unproxiedEndRange
        ? getProxyStartDate({
            proxyType: 'EXTRAPOLATE',
            proxiedStartDate: investment.startRange,
            unproxiedEndDate: investment.unproxiedEndRange,
            proxiedFrequency: frequency,
          })
        : metric.proxiedStart);
  }

  let end = metric.proxiedEnd;
  const isBackfillOrExtrapolate = ['BACKFILL', 'EXTRAPOLATE'].includes(metric.proxyType);
  if (metric.proxyType === 'EXTRAPOLATE' && metric.extrapolatedEnd) {
    end = metric.extrapolatedEnd;
  } else if (isBackfillOrExtrapolate && investment.unproxiedEndRange && investment.unproxiedStartRange) {
    end = getProxyEndDate({
      proxyType: metric.proxyType,
      extrapolate,
      unproxiedEndDate: investment.unproxiedEndRange,
      proxiedStartDate: investment.startRange,
      unproxiedStartDate: investment.unproxiedStartRange,
      proxiedFrequency: frequency,
      proxiedEndDate: investment.endRange,
    });
  }

  return { start, end };
};
